export const APP_NAME = 'vertical_page_perseus';

export const ROUTE_KEYS = {
    DEFAULT: 'unknown',
    SEARCH: 'search',
    FETCH_VERTICALS_CMS_DATA_BY_ID: 'fetch_verticals_cms_data_by_id',
    FETCH_SEO_DATA_BY_VERTICAL_ID: 'fetch_seo_data_by_vertical_id',
    FETCH_CATEGORY_BUILDER_DATA: 'fetch_category_builder_data',
};
